import { render, staticRenderFns } from "./AssociateOrderList.vue?vue&type=template&id=4d4352a5&scoped=true&"
import script from "./AssociateOrderList.vue?vue&type=script&lang=js&"
export * from "./AssociateOrderList.vue?vue&type=script&lang=js&"
import style0 from "./AssociateOrderList.vue?vue&type=style&index=0&id=4d4352a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4352a5",
  null
  
)

export default component.exports